module.exports = __webpack_public_path__ + "img/wa03.cb2861db.jpg";